'use client'

import { DopCollapse } from '@/components/template/DopCollapse'
import { useEffect, type SyntheticEvent } from 'react'
import Checkbox from '@/components/ui/Checkbox'
import { useSearchParams, usePathname, useRouter } from 'next/navigation'
import { useFilterStore } from '@/store/useFilterStore'
import type { SectionCollapseProps, SectionOption } from './utils/sectionType'


export const SectionCollapse = ({
    title,
    options,
    paramName,
    storeKey,
    defaultSelected = [],
}: SectionCollapseProps) => {
    const router = useRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()

    const selected = useFilterStore((s) => {
        if (storeKey === 'sections') return s.selectedSections
        if (storeKey === 'genders') return s.selectedGenders
        return s.selectedSeasons
    })

    const setValues = useFilterStore((s) => {
        if (storeKey === 'sections') return s.setSections
        if (storeKey === 'genders') return s.setGenders
        return s.setSeasons
    })

    const toggle = useFilterStore((s) => {
        if (storeKey === 'sections') return s.toggleSection
        if (storeKey === 'genders') return s.toggleGender
        return s.toggleSeason
    })

    useEffect(() => {
        const params = new URLSearchParams(searchParams.toString())
        const fromUrl = params.getAll(paramName)
        if (fromUrl.length) setValues(fromUrl)
    }, [])

    const updateUrl = (values: string[]) => {
        const params = new URLSearchParams(searchParams.toString())

        params.delete(paramName)
        values.forEach((v) => params.append(paramName, v))

        if (params.has('page')) params.set('page', '1')

        router.replace(`${pathname}?${params.toString()}`, { scroll: false })
    }

    const handleChange = (values: string[], e: SyntheticEvent) => {
        setValues(values)
        updateUrl(values)
    }

    return (
        <DopCollapse title={title} defaultOpen>
            <Checkbox.Group
                className="flex flex-col gap-1 p-1"
                value={selected}
                onChange={handleChange}
            >
                {options.map((opt) => (
                    <Checkbox key={opt.value} value={opt.value}>
                        {opt.label}
                    </Checkbox>
                ))}
            </Checkbox.Group>
        </DopCollapse>
    )
}
